import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

let didTaboolaScriptLoad = false;

export default class Taboola extends Component {
  static propTypes = {
    networkId: PropTypes.string.isRequired,
    dataPlacement: PropTypes.string,
    mode: PropTypes.string,
    targetType: PropTypes.string,
    siteId: PropTypes.string,
    simulateDomain: PropTypes.string
  }

  static defaultProps = {
    networkId: '',
    mode: 'thumbnails-a',
    targetType: 'mix'
  }

  state = {
    widgetId: _.uniqueId('taboolaWidget')
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      window['_taboola'] = window['_taboola'] || [];
      window['_taboola'].push({ article: 'auto' });

      const { networkId, dataPlacement, mode, targetType, siteId, simulateDomain } = this.props;
      const { widgetId } = this.state;

      // push a taboola article into the _taboola array. Once the script bellow's loaded, it will render them all.
      window['_taboola'].push({
        mode,
        site: siteId,
        container: widgetId,
        placement: dataPlacement || widgetId,
        target_type: targetType
      });

      if (!didTaboolaScriptLoad) {
        const $ = window['$'];

        $.getScript(`https://cdn.taboola.com/libtrc/${networkId}/loader.js${simulateDomain ? `?taboola_sim_domain=${simulateDomain}` : ''}`);
        didTaboolaScriptLoad = true;
      }
    }
  }

  render() {
    const { widgetId } = this.state;

    return (
      <div id={widgetId} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ads/Taboola.js